<template>
  <v-dialog v-model="infoDialog">
    <template v-slot:activator="{ on: dialogOn, attrs }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: slotOn }">
          <v-avatar v-on="{ ...dialogOn, ...slotOn }" v-bind="attrs" slot="activator">
            <v-icon>mdi-information</v-icon>
          </v-avatar>
        </template>
        <span>{{ $t('notifications') }}</span>
      </v-tooltip>
    </template>
    <!-- お知らせ情報 -->

    <v-data-table
      dense
      :headers="headers"
      :items="items"
      hide-default-footer
      item-key="id"
      class="v-data-table-outlined"
    >
      <template v-slot:[`item.infoFileUrl`]="{ item }">
        <v-btn v-if="item.infoFile" @click="downloadInfoFile(item)" color="primary" dark small depressed>{{
          $t('attachedFile')
        }}</v-btn>
      </template>
    </v-data-table>
  </v-dialog>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'Info',
    components: {},
    data: () => ({
      items: [],
      infoDialog: false,
    }),
    computed: {
      headers() {
        return [
          { text: this.$t('notifications'), align: 'start', value: 'infoNm', sortable: false },
          { text: this.$t('attachedFile'), align: 'start', value: 'infoFileUrl', sortable: false },
        ];
      },
    },
    created() {
      this.getInfomations();
    },
    mounted() {},
    methods: {
      async getInfomations() {
        console.info('Azure API開始');
        try {
          const targetDateTime = moment.utc().format('YYYY-MM-DD HH:mm:ss.SSSSSSS');
          const info = await this.azureRequest('/api/getInformationsDisplay', 'GET', {
            targetDateTime: targetDateTime,
          });
          this.items = info;

          this.infoDialog = false;

          if (this.items && this.items.length !== 0) {
            // お知らせのIDリストを抽出
            const idList = await info.map((el) => el.id);
            // cookieから表示済みIDリストを取得
            const cookieValue = this.$cookies.get('infoDisplayed');
            const infoDisplayed = Array.isArray(cookieValue) ? cookieValue : [];
            // cookieに保存されていないお知らせIDを抽出
            const unDisplay = idList.find((infoId) => !infoDisplayed.find((displayed) => infoId === displayed));
            // 新しいお知らせがあればポップアップ
            this.infoDialog = unDisplay && unDisplay.length > 0;
            // 表示済みお知らせを更新
            this.$cookies.set('infoDisplayed', idList, Infinity);
          } else {
            // お知らせが無ければcookieを除去
            this.$cookies.remove('infoDisplayed');
          }
        } catch (error) {
          console.error(error);
        } finally {
          console.info('Azure API完了');
        }
      },
      async downloadInfoFile(item) {
        console.info('Azure API開始');
        try {
          const file = await this.azureRequest('/api/getInformationFiles', 'GET_BLOB', {
            id: item.id,
            infoFile: item.infoFile,
          });

          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(file);
          // ファイル名の生成
          link.download = `${item.infoFile}.pdf`;
          link.click();
        } catch (error) {
          console.error(error);
        } finally {
          console.info('Azure API完了');
        }
      },
    },
  };
</script>
<style></style>
